<div class="container-fluid">
  <div class="row mb-4">
    <div class="fw-bold fs-27 col-md-6 col-12 mt-2">
      System Setup
      <div class="border-green-bottom"></div>
    </div>
    <div class="col-md-6 col-12 mt-2 d-flex justify-content-md-end">
      <div class="search-area">
        <div [innerHtml]="SVG_ICONS.SEARCH_ICON() | sanitizer : 'html'" class="position-absolute mt-2 ms-2"></div>
        <input type="text" class="search-input" placeholder="Search User" (keyup)="applyFilter($event)" />
      </div>
    </div>
  </div>
  <div class="table-responsive-scroll">
    <table mat-table [dataSource]="dataSource" class="mat-elevation-z1 w-100" matSort>
      <!-- User ID Column -->
      <ng-container matColumnDef="UMID">
        <th mat-header-cell *matHeaderCellDef mat-sort-header class="fs-14 fw-bold font-gray p-3 font-gray">User ID</th>
        <td mat-cell *matCellDef="let item" class="p-3 font-white">{{ item.UMID }}</td>
      </ng-container>

      <!-- User Name Column -->
      <ng-container matColumnDef="UserLoginID">
        <th mat-header-cell *matHeaderCellDef mat-sort-header class="fs-14 fw-bold font-gray p-3 font-gray">User Name
        </th>
        <td mat-cell *matCellDef="let item" class="p-3 font-white">{{ item.UserLoginID }}</td>
      </ng-container>

      <!-- Email Column -->
      <ng-container matColumnDef="UserEmail">
        <th mat-header-cell *matHeaderCellDef mat-sort-header class="fs-14 fw-bold font-gray p-3 font-gray">User Email
        </th>
        <td mat-cell *matCellDef="let item" class="p-3 font-white">{{ item.UserEmail }}</td>
      </ng-container>

      <!-- Mobile Column -->
      <ng-container matColumnDef="UserMobile">
        <th mat-header-cell *matHeaderCellDef mat-sort-header class="fs-14 fw-bold font-gray p-3 font-gray">User
          MobileNo</th>
        <td mat-cell *matCellDef="let item" class="p-3 font-white">
          <a href="tel: +91 {{ item.UserMobile }}" class="font-white fs-14 fw-normal text-decoration-none">+91 {{
            item.UserMobile }}</a>
        </td>
      </ng-container>

      <!-- Action Column -->
      <ng-container matColumnDef="action">
        <th mat-header-cell *matHeaderCellDef class="fs-14 fw-bold font-gray p-3 font-gray">Action</th>
        <td mat-cell *matCellDef="let item" class="p-3">
          <button mat-icon-button (click)="onAction(item.UMID)" (keydown.enter)="onAction(item.UMID)"
            (keydown.space)="onAction(item.UMID)" tabindex="0">
            <div [innerHtml]="SVG_ICONS.EDIT_PENCIL() | sanitizer : 'html'" role="button"></div>
          </button>
        </td>
      </ng-container>

      <!-- Header & Row Definitions -->
      <tr mat-header-row *matHeaderRowDef="displayedColumns" class="border-bottom"></tr>
      <tr mat-row *matRowDef="let row; columns: displayedColumns" class="border-bottom"></tr>
    </table>
    <mat-paginator [pageSizeOptions]="[10, 20, 100]" [length]="Pagelength" showFirstLastButtons
      class="mt-3"></mat-paginator>
  </div>
</div>